goog.provide("shadow.js.shim.module$$mui$material$CardHeader");
goog.provide("module$shadow_js_shim_module$$mui$material$CardHeader");
shadow.js.shim.module$$mui$material$CardHeader = shadow.js.nativeProvides["@mui/material/CardHeader"] = shadow$bridge("@mui/material/CardHeader");
module$shadow_js_shim_module$$mui$material$CardHeader.default = shadow.js.shim.module$$mui$material$CardHeader;
